var codeExecuted = false;

  const europeanUnionCountries = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE",
  "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT",
  "RO", "SK", "SI", "ES", "SE"
];

async function isUserFromEUProductCard() {
  console.log("EUEUEU")
  let countryCode = localStorage.getItem('userGeolocation');

  if (!countryCode) {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const json = await response.json();
      countryCode = json.country_code;
      localStorage.setItem('userGeolocation', countryCode);
    } catch (error) {
      console.error("❌ Не удалось определить страну пользователя:", error);
      return false;
    }
  }

  return europeanUnionCountries.includes(countryCode);
}

async function changeUsdToEuroProductCards() {
  const isEU = await isUserFromEUProductCard();
  if (!isEU) {
    console.log("🌍 Пользователь не из ЕС — цены остаются в USD");
    return;
  }

  document.querySelectorAll(".product-card-info .money, .product-card-info #first-price .money, .product-card-info #final-price .money, .product-card-info #final-price-two .money, .product-card-info #final-price-precents-desktop .money, .product-card-info #final-price-precents-desktop-two .money").forEach((el) => {
    el.textContent = el.textContent
      .replace(/\$([\d.,]+)\s*USD/i, "$1 €")
      .replace(/USD\s*\$([\d.,]+)/i, "$1 €");

  });
  console.log("💶 Цены переведены в евро (карточки товаров)");
}

async function calculateAndDisplayDiscount(
  priceElement,
  discountAmount,
  discountType
) {
  const isEU = await isUserFromEUProductCard();
  var priceString = priceElement.textContent.trim().replace("$", "");
  var price = parseFloat(priceString);

  var discountedPrice =
    discountType === "percentage"
      ? Math.round(price * (1 - discountAmount / 100))
      : Math.round(price - discountAmount);
  if (!isEU) {
    priceElement.textContent = "$" + discountedPrice;
  } else {
    priceElement.textContent = "€" + discountedPrice;
  }
}

function executeCodeOnce() {
  if (codeExecuted) return;

  var discountAmountFromCMC =
    document.querySelector("#discount-amount")?.textContent || 0;

  var discountAmountFromCMCSecond =
    document.querySelector("#discount-amount-two")?.textContent || 0;

  var discountPercentsFromCMC =
    document.querySelector("#discount-percents")?.textContent || 0;

  var discountPercentsFromCMCTwo =
    document.querySelector("#discount-percents-two")?.textContent || 0;

  var priceElement = document.querySelectorAll("#final-price .money");
  var priceElementAmountTwo = document.querySelectorAll("#final-price-two .money");
  var priceElementPercents = document.querySelectorAll("#final-price-precents-desktop .money");
  var priceElementPercentsTwo = document.querySelectorAll("#final-price-precents-desktop-two .money");

  priceElement.forEach((price) => {
    calculateAndDisplayDiscount(price, discountAmountFromCMC, "amount");
  });

  priceElementAmountTwo.forEach((price) => {
    calculateAndDisplayDiscount(price, discountAmountFromCMCSecond, "amount");
  });

  priceElementPercents.forEach((price) => {
    calculateAndDisplayDiscount(price, discountPercentsFromCMC, "percentage");
  });

  priceElementPercentsTwo.forEach((price) => {
    calculateAndDisplayDiscount(price, discountPercentsFromCMCTwo, "percentage");
  });

  codeExecuted = true;

  // После применения скидки — заменяем валюту
(async () => {
  await changeUsdToEuroProductCards();
})();
}


document.addEventListener("DOMContentLoaded", executeCodeOnce);